import { Model as r } from "../../../../../../model.js";
class o extends r {
  constructor(e) {
    super(), this.repeat = e.repeat, this.rules = e.rules;
  }
}
export {
  o as TierCycleModel
};
//# sourceMappingURL=tierCycle.model.js.map
